module.exports = __webpack_public_path__ + "static/img/harpy.7e6a228.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/harpy.png
// module id = p6Yf
// module chunks = 0